import { ModalPopup } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import HtmlParser from 'html-react-parser';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { bodyCopyMedium, headlineSmall } from '../../common';

export const Content = styled.div`
	div {
		display: block;
	}
`;

export const Lead = styled.div`
	${headlineSmall}
	text-align: center;
	margin-bottom: 20px;
	width: 100%;
`;
export const Body = styled.div`
	${bodyCopyMedium}
`;

export interface IFinalConfirmationProps {
	show: boolean;
	publishing: boolean;
	cancel: () => void;
	submit: () => void;
}

export class FinalConfirmation extends React.Component<IFinalConfirmationProps> {
	public render() {
		return (
			<ModalPopup
				isOpen={this.props.show}
				title={ContentConstants.CONFIRMSCHEDULE_FINALCONFIRMATION_TITLE}
				contentfullwidth={false}
				contenthcentered={true}
				contentvcentered={true}
				onClosed={this.props.cancel}
				onSubmit={this.props.submit}
				primaryButtonDisabled={this.props.publishing}
				secondaryButtonText={ContentConstants.BUTTONS_CANCEL}
				primaryButtonText={ContentConstants.BUTTONS_CONTINUE}
			>
				<Content>
					<Lead>{ContentConstants.CONFIRMSCHEDULE_FINALCONFIRMATION_LEAD}</Lead>
					<Body>{HtmlParser(ContentConstants.CONFIRMSCHEDULE_FINALCONFIRMATION_BODY)}</Body>
				</Content>
			</ModalPopup>
		);
	}
}
